import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { popularDestinationsAction } from 'store/popularDestinations';
import { HotOffersSection } from 'containers/Home/fragments';
import { StepsSection } from './fragments/stepsSection';
import { PopularSection } from 'containers/Welcome/fragments/PopularSection';
import { HowItsWorkPage } from './styled';

export const HowItsWork = () => {
  const { popularDestination } = useSelector((state) => state.popularDestination);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(popularDestinationsAction.getPopularDestinations());
  }, [dispatch]);

  return (
    <HowItsWorkPage>
      <StepsSection />
      <HotOffersSection popularDestination={popularDestination} />
      <PopularSection />
      {/*  TO DO */}
      {/*<Footer />*/}
    </HowItsWorkPage>
  );
};
